<template>
    <el-dialog
      :title="title"
      :visible.sync="disableDialog"
      append-to-body
      width="414px">
      <span style="padding-left:30px;" v-html="content"></span>
      <span slot="footer" class="dialog-center" v-show="max === undefined">
        <el-button type="primary" @click="onSubmit">确 定</el-button>
        <el-button @click="disableDialog = false">取 消</el-button>
      </span>
       <span slot="footer" class="dialog-center" v-show="max ==='max'">
        <el-button type="primary" @click="onSubmitPrice">前往充值</el-button>
        <el-button @click="disableDialog = false">调整付款项</el-button>
      </span>
    </el-dialog>
</template>
<script>
export default {
  props: ['title', 'content'],
  data () {
    return {
      disableDialog: false,
      params: {},
      max: undefined// 申请付款时的前往充值
    }
  },
  methods: {
    onInitial (row, max) {
      this.params = row
      this.max = max// 付款时的时候余额不足
      this.disableDialog = true
    },
    // 确定
    onSubmit () {
      if (!this.disableDialog) return
      this.disableDialog = false
      this.$nextTick(() => {
        this.$emit('onUpdataState', this.params)
      })
    },
    onSubmitPrice () {
      this.$emit('onUpdataStatePrice')
      this.disableDialog = false
    }
  }
}
</script>
